import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return {
      top: 0
    };
  },
  linkActiveClass: 'is-active',
  routes: [{
    path: "/",
    redirect: "/index",
    component: () => import("../layout/layout.vue"),
    children: [{
      name: "index",
      path: "/index",
      component: () => import("../views/index.vue"),
      meta: {
        title: "科比软件",
        index:'0',
      }
    },
    {
      name: "intro",
      path: "/intro",
      component: () => import("../views/homes/intro.vue"),
      meta: {
        title: "科比软件",
        index:'1',
        keepAlive: false,
      },
    },
    {
      name: "help",
      path: "/help",
      component: () => import("../views/homes/help.vue"),
      meta: {
        title: "科比软件",
        index:'3'
      },
    },
    {
      name: "pricing",
      path: "/pricing",
      component: () => import("../views/homes/pricing.vue"),
      meta: {
        title: "科比软件",
        index:'2'
      },
    },
    {
      name: "version",
      path: "/version",
      component: () => import("../views/homes/version.vue"),
      meta: {
        title: "科比软件",
        index:'5'
      },
    },
    {
      name: "loading",
      path: "/loading",
      component: () => import("../views/homes/loading.vue"),
      meta: {
        title: "科比软件",
        index:'6',
      },
    },
    {
      name: "news",
      path: "/news",
      component: () => import("../views/homes/news.vue"),
      meta: {
        title: "科比软件",
        index:'4'
      },
    },
    {
      name: "details",
      path: "/details",
      component: () => import("../views/homes/details.vue"),
      meta: {
        title: "科比软件",
        index:'4'
      },
    },
    {
      name: "controlpanel",
      path: "/controlpanel",
      component: () => import("../views/homes/controlpanel.vue"),
      meta: {
        title: "科比软件",
        index:'16'
      },
    }
    
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js